import React from "react"
import styled from "styled-components"
import {DataTableRow} from "./DataTableRow"

const DataTable = (props) => {
  const cells = {}

  props.columns.forEach((column) => {
    cells[column.code] = column.name
  })

  return (
    <OuterDiv>
      <HeaderDiv>
        <DataTableRow
          align={props.align}
          cells={cells}
          columns={props.columns}
          firstColumnWidth={props.firstColumnWidth}
          name={props.name}
          renderCell={props.renderHeader}
        />
      </HeaderDiv>
      <div>
        {props.rows.map((row, rowKey) => {
          const striped = rowKey % 2 === 0
          return (
            <DataTableRow
              align={props.align}
              bold={row.bold}
              cells={row.cells}
              columns={props.columns}
              firstColumnWidth={props.firstColumnWidth}
              formula={row.formula}
              key={rowKey}
              name={row.name}
              renderCell={props.renderValue}
              rows={row.rows}
              striped={striped}
            />
          )
        })}
      </div>
    </OuterDiv>
  )
}

const HeaderDiv = styled.div`
  color: ${(props) => props.theme.textColorLight};
`

const OuterDiv = styled.div`
  border: 1px solid ${(props) => props.theme.borderColorLight};
  border-bottom: 0;
  &:not(:last-of-type) {
    margin-bottom: ${(props) => props.theme.gutter}px;
  }
`

DataTable.defaultProps = {
  columns: [],
  firstColumnWidth: "25%",
  renderHeader: (header) => header,
  renderValue: (value) => value,
  rows: [],
}

export {DataTable}
